"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("./button.style");
var _LoadingIndicator = _interopRequireDefault(require("../LoadingIndicator"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const Button = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      iconPosition = 'left',
      type = 'button',
      icon,
      label,
      id,
      loading = false,
      fit = 'medium',
      variant = 'filled',
      appearance = 'default',
      width = 'auto',
      justifyItems = 'center',
      href,
      rel,
      target,
      className = 'button',
      arialabel,
      ariacurrent = false,
      disabled
    } = props,
    rest = __rest(props, ["iconPosition", "type", "icon", "label", "id", "loading", "fit", "variant", "appearance", "width", "justifyItems", "href", "rel", "target", "className", "arialabel", "ariacurrent", "disabled"]);
  const computedAriaLabel = () => {
    const labelOrIcon = label || icon;
    return arialabel ? arialabel : labelOrIcon;
  };
  const getSize = fit === 'large' ? '24' : '20';
  const loader = isInverse => {
    return (0, _jsxRuntime.jsx)(_LoadingIndicator["default"], {
      className: "button-loader",
      fit: fit,
      appearance: isInverse ? 'default' : 'inverted',
      id: "loading"
    });
  };
  const showIcons = () => {
    if (icon) {
      return (0, _jsxRuntime.jsx)(_button.Components.IconWrapper, {
        name: icon,
        size: getSize,
        label: label
      });
    }
  };
  return (0, _jsxRuntime.jsxs)(_button.Components.CommonWrapper, (0, _extends2["default"])({
    className: "".concat(className, "-wrapper"),
    disabled: disabled,
    width: width
  }, {
    children: [(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: href && href.length > 0 ? (0, _jsxRuntime.jsxs)(_button.Components.Anchor, (0, _extends2["default"])({
        id: id,
        iconPosition: iconPosition,
        "$loading": loading,
        fit: fit,
        variant: variant,
        appearance: appearance,
        type: type,
        justifyItems: justifyItems,
        width: width,
        icon: icon,
        className: className,
        label: label,
        "aria-label": computedAriaLabel(),
        "aria-current": ariacurrent,
        href: href,
        disabled: disabled
      }, rest, {
        children: [iconPosition === 'left' && showIcons(), label && label.length > 0 && (0, _jsxRuntime.jsx)("span", {
          children: label
        }), iconPosition === 'right' && showIcons()]
      })) : (0, _jsxRuntime.jsxs)(_button.Components.ButtonArea, (0, _extends2["default"])({
        id: id,
        iconPosition: iconPosition,
        "$loading": loading,
        fit: fit,
        variant: variant,
        appearance: appearance,
        type: type,
        justifyItems: justifyItems,
        width: width,
        icon: icon,
        ref: ref,
        className: className,
        label: label,
        "aria-label": computedAriaLabel(),
        "aria-current": ariacurrent,
        disabled: disabled
      }, rest, {
        children: [iconPosition === 'left' && showIcons(), label && label.length > 0 && (0, _jsxRuntime.jsx)("span", {
          children: label
        }), iconPosition === 'right' && showIcons()]
      }))
    }), loading && (0, _jsxRuntime.jsx)(_button.Components.LoaderWrapper, (0, _extends2["default"])({
      fit: fit
    }, {
      children: loader(appearance === 'inverse')
    }))]
  }));
});
var _default = exports["default"] = Button;